import { useContext } from 'react';
import ReactMarkdown from 'react-markdown';
import { Checkbox } from '@arionbanki/arionui';
import { AppContext } from 'providers/AppProvider';

type ProductListProps = Readonly<{
	disabled?: boolean;
	products: string[];
	selected: string[];
	setSelected: (arr: string[]) => void;
}>;

export function ProductList({ selected, ...props }: ProductListProps) {
	const { t } = useContext(AppContext);

	const content = props.products.map(product => {
		const id = product.toLowerCase();
		return (
			<div className="row my-4 product-panel" key={id}>
				<div className="col-lg-6">
					<Checkbox
						checked={selected.some(x => id === x)}
						disabled={props.disabled}
						id={id}
						label={t(`${id}_title`, 'products')}
						onChange={checked => {
							props.setSelected(checked ? [...selected, id] : selected.filter(x => id !== x));
						}}
					/>
					<p>{t(`${id}_description`, 'products')}</p>
				</div>
				<div className="col-lg-6">
					<ReactMarkdown>{t(`${id}_list`, 'products')}</ReactMarkdown>
				</div>
			</div>
		);
	});

	return <>{content}</>;
}
